/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
/* eslint-disable max-len */
import React, { useEffect } from 'react'
import {useContext ,useState} from "react"
import GlobalContext from '../../../../../components/Context/GloablContext'
import Pagination from '../../../../../components/Pagination'
import Limit from '../../../../../components/Limit'
import CustomOverLay from '../../../../../components/CustomOverLay'
import SearchEmptyScreen from '../../../../../components/SearchEmptyScreen'
import BloodGlouseVitalTable from './Components/Table'
import moment from 'moment'
import Emptyscreenwithouttitle from '../../../../../components/Emptyscreenwithouttitle'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { useExportDeviceVitalReadingListMutation, useVitalReadingListQuery ,useGetHelpGuideAdminQuery} from '../../../../../features/patientSlice'
import BloodGlouseVitalTopBar from './Components/Topbar'
import { handleAddFilterValues } from '../../../../../redux/systemConfigSlice'
import { useDispatch, useSelector } from 'react-redux'
import TopHeader from '../../../../../components/TopHeader'
import HelpGuideModal from '../../../../../components/HelpGuideModal'
import DeviceAlertDashboardSearch from '../../../../Dashboard/ViewPatient/AdvancedSearch'
import { resetDeviceAlertDashboardSearch, setDeviceAlertDashboardSearchApplied } from '../../../../../redux/deviceAlertDashboardSlice'

export default function BloodGlouseVitalList({device}) {
    const {isSideBar,isAdvancedSearchOpen,setIsSearchOpen,setIsAdvancedSearchOpen} = useContext(GlobalContext);
    const [exportDeviceVitalDetails]= useExportDeviceVitalReadingListMutation()
    const [isColumnSelect,setIsColumnSelect] = useState(false)
    const initialState={
        "filter_start_date":'',
        "filter_end_date":'',
    }
    const [filterValues,setFilterValues]=useState(initialState)
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [searchParams,setSearchParams] = useSearchParams()
    const {data,isFetching,status}=useVitalReadingListQuery( searchParams.toString(),{skip:searchParams.size<4,refetchOnMountOrArgChange:true})
    const dispatch = useDispatch()
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        params.last_page = null
        params.last_id = null
        if(key === 'search') {params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });

    const deviceDashboardSearch = useSelector(state => state.deviceAlertDashboardSearchData);
    const navigate = useNavigate()
    
    
    
    useEffect(() => {
        if (device===undefined) {
            if (userType === 'corporate-user') {
                setQueryParamsadmin('type=corporate-vital-history');
            } else {
                setQueryParamsadmin('type=admin-patient-vital-history');
            }
        } else {
            if (userType === 'corporate-user') {
                setQueryParamsadmin('type=corporate-patients-device-reading-history');
            } else {
                setQueryParamsadmin('type=admin-patient-device-reading-history');
            }
        }
    }, [userType,device]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);

    const handleApplyFilter=(type)=>{
        let params = Object.fromEntries(searchParams);
        const start_date=moment(filterValues.filter_start_date).format('YYYY-MM-DD')
        const end_date=moment(filterValues.filter_end_date).format('YYYY-MM-DD')
        dispatch(handleAddFilterValues({
            "filter_start_date":filterValues.filter_start_date,
            "filter_end_date":filterValues.filter_end_date,

        }))

      
        if(type){
            params.page_number=1
            params.last_page = null
            params.last_id = null
            filterValues?.filter_start_date!==""&&filterValues?.filter_start_date!==undefined?params["start_date"]=start_date:''
            filterValues?.filter_end_date!==""&&filterValues?.filter_end_date!==undefined?params["end_date"]=end_date:''
            setSearchParams({...params})
        }
        else{
            params.start_date&&delete params.start_date
            params.end_date&&delete params.end_date
            setSearchParams({ ...params})
        } 
    }

    const [limit,setLimit]=useState("15")

    function handleNoOfRowsClick(number) {
        // setLoading(true);
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        params['last_id']=null
        params['last_page'] =null
        setSearchParams({ ...params });
    }

    const handleOnClickPageNumber = (pageNum) => {
        // setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum,last_id:(pageNum===1?null:searchParams?.get('page_number')>pageNum?(data?.historical_reading?.[0]?._id!==undefined?data?.historical_reading?.[0]?._id:null):(data?.historical_reading?.[data?.historical_reading?.length-1]?._id!==undefined?data?.historical_reading[data?.historical_reading?.length-1]?._id:null)),last_page:(pageNum===1?null:searchParams?.get('page_number')>pageNum?searchParams?.get('page_number'):searchParams?.get('page_number')) })
        // dispatch(addToTopCheckbox([pageNum.selected+1,searchParams.get("limit")]))
    }

    useEffect(() => {
        let params = {}
        params.limit='15'
        params.page_number='1'
        params.reading_type='all'
        params.filter='true',
        params.type='readings',
        params.last_id=data===undefined?null:data?.historical_reading?.[data?.historical_reading?.length-1]?._id,
        params.last_page=null
        params.patient_id=device===undefined?location.pathname.split('/')?.[4]:location.pathname.split('/')?.[5]
        searchParams?.size===0&&setSearchParams({...params})
        
    }, [location]);

    const handleSearchSubmit = (e) => {        
        e.preventDefault();
    
        let searchString = '';     
        // Utility function to handle __NULL__ logic for search values
        const formatSearchValue = (value) => {
            const trimmedValue = value.trim();
            return trimmedValue === '-' ? '__NULL__' : trimmedValue;
        };

        // Check for `device_id` and `device_id_inverse` conditions
        if (deviceDashboardSearch?.device_id && deviceDashboardSearch.device_id.trim() !== '') {
            const deviceIdPrefix = deviceDashboardSearch.device_id_inverse ? 'ne:' : '';
            const formattedDeviceId = formatSearchValue(deviceDashboardSearch.device_id);
            searchString += `device_id=${deviceIdPrefix}${encodeURIComponent(formattedDeviceId)};`;
        }

        // Check for `reading` and `reading_inverse` conditions
        if (deviceDashboardSearch?.reading && deviceDashboardSearch.reading.trim() !== '') {
            const readingsPrefix = deviceDashboardSearch.reading_inverse ? 'ne:' : '';
            const formattedReadings = formatSearchValue(deviceDashboardSearch.reading);
            searchString += `reading=${readingsPrefix}${encodeURIComponent(formattedReadings)};`;
        }

        // check for reading_type field
        if (deviceDashboardSearch?.reading_type) {
            const readingTypePrefix = deviceDashboardSearch.reading_type_inverse ? 'ne:' : '';
            const formattedReadingType = formatSearchValue(deviceDashboardSearch.reading_type)
                .toLowerCase() 
                .replace(/\s+/g, '_');
            searchString += `reading_type=${readingTypePrefix}${encodeURIComponent(formattedReadingType)};`;
        }

        searchString = searchString.endsWith(';') ? searchString.slice(0, -1) : searchString;

        // Merge all search parameters into a single object
        const currentParams = Object.fromEntries(searchParams); // Get existing params
        const newParams = {
            ...currentParams, // Preserve existing params (limit, sort, etc.)
            search: searchString || '', // Add search string
            search_mode: deviceDashboardSearch.match === false ? 'and' : 'or', // Add search mode
            page_number: 1, // Reset page number on new search
            limit: currentParams.limit || '15', // Keep limit or set default
            last_id:null,
            last_page:null
        };
    
        // Remove empty search key if search string is empty
        if (!newParams.search) delete newParams.search;
    
        // Update all searchParams in one go to avoid multiple re-renders or API calls
        setSearchParams(newParams);
        dispatch(setDeviceAlertDashboardSearchApplied());
    };

    // handle navigation function
    const handleNavigation = (path, state) => {
        setIsAdvancedSearchOpen(false);
        dispatch(resetDeviceAlertDashboardSearch());
        navigate(path, { state });
    };

 
    return (
        <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
            <TopHeader title={`${device===undefined?'Vital':'Device'} Reading History`}/>
           
            <div className='bg-white rounded-lg pt-3 h-customh3 relative'> 
                <div className="flex items-center mx-[28px] mb-3">
                    <>
                        <button 
                            onClick={() => handleNavigation("/manage-patients", Array.isArray(location.state) ? '' : location.state)} 
                            className="text-sm font-normal text-[#52555D]"
                        >
                            List of Patients
                        </button>

                        <span className='mx-2'>
                            <img src="/images/breadcrumb-icon.svg" alt="icon"/>
                        </span>

                        <button 
                            onClick={() => handleNavigation(
                                `/manage-patients/${location.pathname.split('/')?.[2]}`, 
                                device === undefined ? 'vital_screen' : 'device_screen'
                            )}
                            className='items-center min-w-max flex text-sm font-normal text-[#52555D]'
                        >
                            View Patient
                        </button>

                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                        {device===undefined?<h1 className="text-sm font-normal text-[#008586]">View Vital History</h1>:<h1 className="text-sm font-normal text-[#008586]">View Device Reading History</h1>}
                        {
                            userType !=='super-admin' &&
                            <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                            </span> 
                        }
                
                    </>
                </div>      
                <div className="px-6">
                    {data!==undefined&&!isFetching&&<BloodGlouseVitalTopBar
                        device={device}
                        SearchInput={false }
                        ApplyFilter={(searchParams.get("start_date")===null&&searchParams.get("end_date")===null&&(data?.historical_reading?.length===0 || data===undefined)) ? false : true}
                        handleApplyFilter={handleApplyFilter}
                        data={data}
                        exportCols={device===undefined?['Timestamp','Vital Type','Reading','Threshold','Device ID']:['Timestamp','Vital Type','Reading','Device ID']}
                        filterValues={filterValues}
                        setFilterValues={setFilterValues}
                        isColumnSelect={isColumnSelect}
                        setIsColumnSelect={setIsColumnSelect}
                        initialState={initialState}
                        exportVitalDetails={exportDeviceVitalDetails}
                        isFilterOpen={isFilterOpen}
                        setIsFilterOpen={setIsFilterOpen}
                        TotalCount={parseInt(data?.total_count)}
                    />}
                </div>
                {((isFetching&&status!=="fulfilled"&&status!=="rejected")||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text={device===undefined?`Loading Vital Reading History...`:`Loading Device Reading History...`} classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar?'opened_sidebar_overlay':'overlay-list'}`}/>: (data!==undefined && data?.historical_reading?.length > 0 ) ? <>   
                    <div className="px-6">
                        <BloodGlouseVitalTable
                            pageNumber={Number(searchParams.get('page_number')) || 1}
                            List={data}
                            device={device}
                            handleSearchParams={handleSearchParams}
                        />
                    </div>
                    {data?.total_count>=15&&<div className="w-full px-2.5 pt-1 flex items-center justify-between bg-[#F4F7FC] rounded-b-lg">
                        <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                        <div className="flex items-center">
                            <Limit
                                limit={limit}
                                setLimit={setLimit}
                                handleNoOfRowsClick={handleNoOfRowsClick}
                            />
                            <Pagination
                                TotalCount={parseInt(data?.total_count)}
                                totalPageNumber={Math.ceil(parseInt(data?.total_count)/parseInt(searchParams?.get("limit")))}
                                handleOnClickPageNumber={handleOnClickPageNumber}
                                // limit={Number(searchParams.get('limit'))}
                                limit={parseInt(limit)}
                            />
                        </div>
                    </div>}
                </>:<>
                    {(data?.total_count === 0 && (searchParams.get('search') || searchParams.get('search_mode'))) ? (
                        <SearchEmptyScreen text={"No exact matches found. Please try a different search"}
                            deviceReadingHistory={true}
                        />
                    ):
                        data?.historical_reading?.length===0 && (searchParams.get("start_date")!==null||searchParams.get("end_date")!==null) ?
                            <SearchEmptyScreen 
                                vitalFilterHeight={true}
                                text={"That filter combination has no result. Please try different criteria"} 
                            />
                            :
                            data?.total_count===0?<Emptyscreenwithouttitle
                                FirstPTag={`No ${device===undefined?'vital':'device'} reading history to view yet`}
                                vitalHeight={true}
                            />:((status==="rejected"||(data?.total_count!==0&&data?.historical_reading?.length===0))&&<SearchEmptyScreen text={"No data found"} />)
                    
                    }
                </>}
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                />
                }
                {isAdvancedSearchOpen && searchParams?.get('limit') && !searchParams?.get('target_user_name') &&
                <DeviceAlertDashboardSearch
                    handleOnSubmit={handleSearchSubmit}
                    deviceReadingSearch={true}
                />
                }
            </div>
        </div>
            
          
    )
}
